import { render, staticRenderFns } from "./CoinsBackdrop.vue?vue&type=template&id=6abd00d6&scoped=true"
import script from "./CoinsBackdrop.vue?vue&type=script&lang=js"
export * from "./CoinsBackdrop.vue?vue&type=script&lang=js"
import style0 from "./CoinsBackdrop.vue?vue&type=style&index=0&id=6abd00d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abd00d6",
  null
  
)

export default component.exports